import * as els from '../kit';
import { ERFElement } from '../enums';
export const RF_NODE_TYPES = {
    [ERFElement.Element]: els.RFElementNode,
    [ERFElement.Recycle]: els.RFRecycleNode,
    [ERFElement.GroupDashed]: els.RFGroupDashedNode,
    [ERFElement.DotEnergy]: els.RFDotEnergyNode,
    [ERFElement.DotMaterial]: els.RFDotMaterialNode,
    [ERFElement.Absorber]: els.RFAbsorberNode,
    [ERFElement.FlowEnergy]: els.RFFlowEnergyNode,
    [ERFElement.FlowMaterial]: els.RFFlowMaterialNode,
    [ERFElement.Separator2ph]: els.RFSeparator2phNode,
    [ERFElement.Separator3ph]: els.RFSeparator3phNode,
    [ERFElement.CatCracking]: els.RFCatCrackingNode,
    [ERFElement.CatCrackingRRBlock]: els.RFCatCrackingRRNode,
    [ERFElement.CatReforming]: els.RFCatReformingNode,
    [ERFElement.CatReformingRRBlock]: els.RFCatReformingRRNode,
    [ERFElement.DieselFuelHydrotreating]: els.RFDieselFuelHydrotreatingNode,
    [ERFElement.DieselFuelHydrotreatingRBlock]: els.RFDieselFuelHydrotreatingRBlockNode,
    [ERFElement.DistillationColumnRC]: els.RFDistillationColumnRCNode,
    [ERFElement.Compressor]: els.RFCompressorNode,
    [ERFElement.Coker]: els.RFCokerNode,
    [ERFElement.CokerRBlock]: els.RFCokerRNode,
    [ERFElement.Cooler]: els.RFCoolerNode,
    [ERFElement.Heater]: els.RFHeaterNode,
    [ERFElement.Valve]: els.RFValveNode,
    [ERFElement.HeatExchanger]: els.RFHeatExchangerNode,
    [ERFElement.Fractionator]: els.RFFractionatorNode,
    [ERFElement.Mixer]: els.RFMixerNode,
    [ERFElement.ComponentSplitter]: els.RFComponentSplitterNode,
    [ERFElement.Splitter]: els.RFSplitterNode,
    [ERFElement.Detander]: els.RFDetanderNode,
    [ERFElement.Pump]: els.RFPumpNode,
    [ERFElement.Pipeline]: els.RFPipelineNode,
    [ERFElement.HeatExchangerSynthetic]: els.RFHeatExchangerSyntheticNode, // Синтетический элемент
    [ERFElement.MultiStepCoherent]: els.RFMultiStepCoherentNode, // Синтетический элемент
    [ERFElement.MultiStepExternal]: els.RFMultiStepExternalNode, // Синтетический элемент
    [ERFElement.Balancer]: els.RFBalancerNode, // Синтетический элемент
    [ERFElement.EngineTestSynthetic]: els.RFEngineTestSyntheticNode, // Синтетический элемент
    [ERFElement.Function]: els.RFFunctionNode, // Функция (логический элемент)
    [ERFElement.Optimization]: els.RFOptimizationNode // Оптимизатор (логический элемент)
};
//# sourceMappingURL=rfNodes.constants.js.map